import React from "react"

import { getListingRoute } from "~utils/navigation-helpers"
import Breadcrumbs, {
    type BreadcrumItemType,
} from "~components/shared/todo-lib-react-components/breadcrumbs"
import COPY from "~config/copy-constants"
import { CHECKOUT_STEPS } from "~config/constants"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"

interface Props {
    readonly listingId: string
}

export default function BookingBreadcrumbs({ listingId }: Props) {
    const items = useBreadcrumbItems({ listingId })

    return <Breadcrumbs items={items} />
}

function useBreadcrumbItems({
    listingId,
}: {
    listingId: string
}): BreadcrumItemType[] {
    const { isWidget, goToStep, currentStep } = useCheckoutFlow()

    const listingItem = {
        label: COPY.LISTING,
        to: getListingRoute(listingId),
    }
    const isSummaryStep = currentStep === CHECKOUT_STEPS.SUMMARY

    return [
        ...(isWidget ? [] : [listingItem]),
        {
            label: COPY.SUMMARY,
            onClick: () => goToStep({ step: CHECKOUT_STEPS.SUMMARY }),
            isActive: isSummaryStep,
        },
        {
            label: COPY.INFO,
            onClick: () => goToStep({ step: CHECKOUT_STEPS.WIDGET_INFO }),
            isActive: currentStep === CHECKOUT_STEPS.WIDGET_INFO,
            isDisabled: isSummaryStep,
        },
        {
            label: COPY.PAYMENT,
            isActive: currentStep === CHECKOUT_STEPS.PAYMENT,
        },
    ]
}
